import type { TemplateByIdResponse } from '../../../documents/templates/hooks/use-template-by-id.hook';

type StakeholderRef = { fullName: string; id: string };

export const getGrantTemplateFixedSigners = (
  template: null | TemplateByIdResponse,
): Record<string, StakeholderRef> => {
  if (!template?.signatoryTypes?.length || !template.tabs?.length) {
    return {};
  }

  const signerByStakeholderType = new Map<string, null | StakeholderRef>();

  for (const tab of template.tabs) {
    const stakeholderType = tab.stakeholderType?.trim();
    const signerId = tab.signerStakeholder?.id?.trim();

    if (!stakeholderType || !signerId) {
      continue;
    }

    const signer: StakeholderRef = {
      id: signerId,
      fullName: tab.signerStakeholder?.fullName?.trim() ?? '',
    };
    const currentSigner = signerByStakeholderType.get(stakeholderType);

    if (currentSigner == null) {
      signerByStakeholderType.set(stakeholderType, signer);
      continue;
    }

    if (currentSigner.id !== signer.id) {
      signerByStakeholderType.set(stakeholderType, null);
    }
  }

  return template.signatoryTypes.reduce<Record<string, StakeholderRef>>((acc, signatoryType) => {
    const signer = signerByStakeholderType.get(signatoryType.stakeholderType);
    if (!signer) {
      return acc;
    }

    acc[signatoryType.id] = signer;
    return acc;
  }, {});
};
